import {
    Component, OnInit, AfterViewChecked, Input, Output, EventEmitter, Renderer2, ElementRef, OnDestroy
} from '@angular/core';
import {trigger, style, animate, transition, query} from '@angular/animations';
import {LotteriesService} from '../lotteries.service';
import {Subscription} from 'rxjs';
import {SubscriptionsService} from '../_services/subscriptions.service';
import {CartService} from '../_services/cart.service';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss', './dialog.mobile.component.scss'],
    animations: [
        trigger('dialog', [
            transition('* => *', [

                query(':enter',
                    [
                        style({opacity: 0}),
                    ],
                    {optional: true}
                ),

                query(':leave',
                    [
                        style({opacity: 1}),
                        animate('0.2s', style({opacity: 0}))
                    ],
                    {optional: true}
                ),

                query(':enter',
                    [
                        style({opacity: 0}),
                        animate('0.2s', style({opacity: 1}))
                    ],
                    {optional: true}
                )


            ])
        ])
    ]
})
export class DialogComponent implements OnInit, AfterViewChecked, OnDestroy {
    @Input() closable = true;
    @Input() visible: boolean;
    @Input() modalSize: any;
    @Input() preventClosing: boolean;
    @Input() closeOnlyByButton: boolean;
    @Input() enterAnimation: string;
    @Input() exitAnimation: string;
    enterExitAnimation: string;
    overlayAnimation: string;
    holdModalOverlay: boolean;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    closeModal: Subscription;
    isSafari: boolean;

    constructor(private renderer: Renderer2,
                private hostElement: ElementRef,
                public lotteryService: LotteriesService,
                private subscriptionsService: SubscriptionsService,
                private cartService: CartService) {
        this.overlayAnimation = 'fadeIn';
        this.subscriptionsService.getCloseModal().subscribe(data => {
            if (data === true) {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.subscriptionsService.emitModalState(false);
                this.renderer.removeClass(document.body, 'modal-open');
            }
        });
        this.subscriptionsService.getCloseDepositModalSmoothly().subscribe(data => {
            if (data) {
                this.enterExitAnimation = this.exitAnimation;
                this.overlayAnimation = 'fadeOut';
            } else {
                this.enterExitAnimation = this.enterAnimation;
                this.overlayAnimation = 'fadeIn';
            }
        });

        this.subscriptionsService.getHoldModalOverlay().subscribe(data => {
            this.holdModalOverlay = data;
            this.overlayAnimation = '';
        });

        const ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') !== -1) {
            if (ua.indexOf('chrome') === -1) {
                this.isSafari = true;
            }
        }
    }

    ngOnDestroy() {
        if (this.closeModal) {
            this.closeModal.unsubscribe();
        }
    }

    ngOnInit() {
    }

    ngAfterViewChecked() {
        if (this.visible === true) {
            if (!this.enterExitAnimation) {
                this.enterExitAnimation = this.enterAnimation;
            }
            this.renderer.addClass(document.body, 'modal-open');
            this.renderer.addClass(this.hostElement.nativeElement, 'open');
        } else {
            this.renderer.removeClass(this.hostElement.nativeElement, 'open');
        }
    }

    closeLogic(val) {
        if (this.preventClosing !== true) {
            this.visible = false;
            this.visibleChange.emit(this.visible);
            this.subscriptionsService.emitModalState(false);
            this.renderer.removeClass(document.body, 'modal-open');
            this.subscriptionsService.emitCloseAddFundsModal(false);
            this.subscriptionsService.emitToggleContent(true);
            this.subscriptionsService.emitPay(false);
            this.subscriptionsService.emitChangePassword(false);
            this.subscriptionsService.emitModalClosing(true);
            this.cartService.priceRecalculated = true;
        }
        if (this.closeOnlyByButton === true && val === 'button') {
            this.subscriptionsService.emitCloseGame(true);
            this.subscriptionsService.emitToggleContent(true);
            this.subscriptionsService.emitPay(false);
            this.subscriptionsService.emitChangePassword(false);
        }
    }

    close(val) {
        this.subscriptionsService.updateTriggeredEndGameSessionIG(false);
        // this.subscriptionsService.emitNewUser(false);
        if (!this.exitAnimation) {
            this.closeLogic(val);
        } else {
            this.enterExitAnimation = this.exitAnimation;
            this.overlayAnimation = 'fadeOut';
            setTimeout(() => {
                this.visible = false;
                this.visibleChange.emit(this.visible);
                this.closeLogic(val);
                setTimeout(() => {
                    this.visible = false;
                    this.enterExitAnimation = this.enterAnimation;
                    this.overlayAnimation = 'fadeIn';
                }, 350);
            }, 350);

        }
    }
}
